import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "update",
  "use": "update-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"update\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.32 6c-3.3 0-6 2.7-6 6h3l-4 4-4-4h3c0-4.4 3.6-8 8-8 1.6 0 3 .5 4.3 1.2l-1.5 1.5c-.8-.5-1.8-.7-2.8-.7Zm3 6 4-4 4 4h-3c0 4.4-3.6 8-8 8-1.6 0-3-.5-4.3-1.2l1.5-1.5c.8.5 1.8.7 2.8.7 3.3 0 6-2.7 6-6h-3Z\" fill=\"#202426\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol